import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import MovieFilterIcon from '@mui/icons-material/MovieFilter';
import MicIcon from '@mui/icons-material/Mic';
import ArticleIcon from '@mui/icons-material/Article';

const AllianceOverview = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Visión Estratégica
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          La experiencia Supercines continúa en TNO Network
        </Box>
        <Typography
          variant="body1"
          color="textSecondary"
          align="center"
          sx={{ maxWidth: 800, mx: 'auto' }}
        >
          Proponemos una alianza donde <strong>Supercines</strong> proyecta la identidad de <strong>TNO Network</strong> en sala,
          mientras TNO amplifica la cartelera y la experiencia cinematográfica a través de su ecosistema de{' '}
          <strong>Streaming, On-Demand y TNO Digest</strong>, con el sello de calidad comunicacional de{' '}
          <strong>MEM Publicidad</strong>.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              height: '100%',
            }}
          >
            <Box display="flex" justifyContent="center" alignItems="center" marginBottom={1}>
              <MovieFilterIcon sx={{ fontSize: 40, color: theme.palette.primary.main }} />
            </Box>
            <Typography variant="h6" gutterBottom fontWeight={700}>
              Identidad sonora y presencia en cine
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Proyección de un spot de <strong>20 segundos</strong> con la voz institucional de{' '}
              <strong>María Eugenia Moreno (MEM Publicidad)</strong> antes de la función, presentando a TNO
              como la plataforma donde el cine se transforma en conversación y contenido permanente. Un mensaje
              directo que posiciona a TNO Network como el destino definitivo para el contenido multiplataforma.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              height: '100%',
            }}
          >
            <Box display="flex" justifyContent="center" alignItems="center" marginBottom={1}>
              <MicIcon sx={{ fontSize: 40, color: theme.palette.primary.main }} />
            </Box>
            <Typography variant="h6" gutterBottom fontWeight={700}>
              MEM Publicidad: el programa
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Integración de <strong>Supercines</strong> como aliado principal en el espacio{' '}
              <strong>MEM Publicidad</strong>, conducido por María Eugenia Moreno: entrevistas de estreno
              con voceros de la industria, invitados especiales y <strong>menciones premium en vivo</strong> invitando
              directamente a la audiencia al cine.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              height: '100%',
            }}
          >
            <Box display="flex" justifyContent="center" alignItems="center" marginBottom={1}>
              <ArticleIcon sx={{ fontSize: 40, color: theme.palette.primary.main }} />
            </Box>
            <Typography variant="h6" gutterBottom fontWeight={700}>
              Cápsulas, streaming y TNO Digest
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Desarrollo de cápsulas audiovisuales como <strong>Supercines Flash-Top</strong> y{' '}
              <strong>Primer Plano Supercines</strong>, junto a la columna{' '}
              <strong>Butaca Digest por Supercines</strong> y una cartelera reforzada en{' '}
              <strong>streaming en vivo</strong>. El contenido on-demand conserva reseñas, micros y análisis que
              permanecen vigentes más allá del estreno, con una estrategia de SEO que mantiene activa la conversación
              sobre Supercines.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AllianceOverview;

